import React, { useEffect, useState } from 'react';

const moeda = valor => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const competencia = valor => valor ? valor.split('-').reverse().join('/') : '—';
const dataHora = valor => valor ? new Date(valor).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

const regra = {
  MENSAL: 'Entram na cobrança mensal os aplicativos de produção que enviaram carga, solicitaram carga ou enviaram pedidos no mês, inclusive os inativados depois do uso.',
  PROPORCIONAL: 'Cobrança proporcional aos dias restantes do mês, gerada na ativação do aplicativo.',
  CANCELAMENTO: 'Cobrança gerada no cancelamento do aplicativo.'
};

export default function FaturaDetalhes({ fatura, api }) {
  const [detalhe, setDetalhe] = useState(null);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;
    api.get(`/faturas/${fatura.id}/aplicativos`).then(resultado => {
      if (!resultado || resultado.error) throw new Error(resultado?.error || 'Não foi possível detalhar a fatura.');
      if (ativo) setDetalhe(resultado);
    }).catch(e => { if (ativo) setErro(e.message); });
    return () => { ativo = false; };
  }, [fatura.id, api]);

  if (erro) return <p className="fatura-detalhe-msg" role="alert">{erro}</p>;
  if (!detalhe) return <p className="fatura-detalhe-msg" role="status">Carregando composição…</p>;

  const { fatura: info, aplicativos } = detalhe;
  return <section className="fatura-detalhe" aria-label={`Composição da fatura ${info.id}`}>
    <header>
      <div>
        <h4>Como chegamos em {moeda(info.valor)}</h4>
        <p>{regra[info.tipo_cobranca] || 'Cobrança avulsa.'}</p>
      </div>
      {aplicativos.length > 0 && info.valor_unitario !== null && <div className="fatura-conta" aria-label="Cálculo da fatura">
        <span><small>Apps</small>{info.quantidade_aplicativos}</span>
        <i aria-hidden="true">×</i>
        <span><small>Valor por app</small>{moeda(info.valor_unitario)}</span>
        <i aria-hidden="true">=</i>
        <span className="total"><small>Total</small>{moeda(info.valor)}</span>
      </div>}
    </header>

    {!aplicativos.length ? <p className="fatura-detalhe-msg">Esta cobrança não tem aplicativos vinculados. {info.descricao}</p> :
      <div className="fatura-apps" role="table" aria-label="Aplicativos considerados">
        <div className="fatura-apps-head" role="row">
          <span role="columnheader">Aplicativo</span>
          <span role="columnheader">Cliente</span>
          <span role="columnheader">{info.tipo_cobranca === 'MENSAL' ? `Último uso em ${competencia(info.mes_referencia)}` : 'Competência'}</span>
          <span role="columnheader">Situação atual</span>
          <span role="columnheader">Valor</span>
        </div>
        {aplicativos.map(app => <div className="fatura-apps-row" role="row" key={app.id}>
          <span role="cell"><strong>{app.nome}</strong><small>#{app.id}</small></span>
          <span role="cell" data-label="Cliente">{app.cliente || '—'}</span>
          <span role="cell" data-label={info.tipo_cobranca === 'MENSAL' ? 'Último uso' : 'Competência'}>
            {info.tipo_cobranca === 'MENSAL' ? dataHora(app.ultima_utilizacao) : competencia(info.mes_referencia)}
          </span>
          <span role="cell" data-label="Situação">{app.removido ? 'Removido' : app.status}</span>
          <span role="cell" data-label="Valor"><strong>{info.valor_unitario !== null ? moeda(info.valor_unitario) : '—'}</strong></span>
        </div>)}
      </div>}
  </section>;
}
